import { render, staticRenderFns } from "./CaseWizard.vue?vue&type=template&id=15d256dc"
import script from "./CaseWizard.vue?vue&type=script&lang=js"
export * from "./CaseWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports